
export const seedTransactions = [
  {"description": "Airtel top-up", "category": "Utilities", "type": "expense"},
  {"description": "Airtel money transfer", "category": "Transfers", "type": "expense"},
  {"description": "TNM bundle", "category": "Utilities", "type": "expense"},
  {"description": "TNM top-up", "category": "Utilities", "type": "expense"},
  {"description": "Electricity token", "category": "Utilities", "type": "expense"},
  {"description": "ESCOM prepaid", "category": "Utilities", "type": "expense"},
  {"description": "Water bill", "category": "Utilities", "type": "expense"},
  {"description": "DSTV subscription", "category": "Entertainment", "type": "expense"},
  {"description": "Netflix subscription", "category": "Entertainment", "type": "expense"},
  {"description": "Shoprite groceries", "category": "Groceries", "type": "expense"},
  {"description": "Shoprite", "category": "Groceries", "type": "expense"},
  {"description": "Game store", "category": "Shopping", "type": "expense"},
  {"description": "Pick n Pay", "category": "Groceries", "type": "expense"},
  {"description": "Fuel refill", "category": "Transport", "type": "expense"},
  {"description": "Petrol station", "category": "Transport", "type": "expense"},
  {"description": "Minibus fare", "category": "Transport", "type": "expense"},
  {"description": "Bus ticket", "category": "Transport", "type": "expense"},
  {"description": "Taxi fare", "category": "Transport", "type": "expense"},
  {"description": "Rent payment", "category": "Housing", "type": "expense"},
  {"description": "Restaurant meal", "category": "Food & Dining", "type": "expense"},
  {"description": "Lunch", "category": "Food & Dining", "type": "expense"},
  {"description": "Hospital bill", "category": "Healthcare", "type": "expense"},
  {"description": "Clinic fee", "category": "Healthcare", "type": "expense"},
  {"description": "Pharmacy", "category": "Healthcare", "type": "expense"},
  {"description": "School fees", "category": "Education", "type": "expense"},
  {"description": "University fees", "category": "Education", "type": "expense"},
  {"description": "Clothes shopping", "category": "Shopping", "type": "expense"},
  {"description": "Salary received", "category": "Salary", "type": "income"},
  {"description": "Monthly salary", "category": "Salary", "type": "income"},
  {"description": "Freelance payment", "category": "Freelance", "type": "income"},
  {"description": "Mpamba received", "category": "Transfers", "type": "income"},
  {"description": "Airtel money received", "category": "Transfers", "type": "income"},
  {"description": "Bank transfer in", "category": "Transfers", "type": "income"},
  {"description": "ATM withdrawal", "category": "Transfers", "type": "expense"},
  {"description": "Bank charges", "category": "Bank Fees", "type": "expense"},
  {"description": "Church offering", "category": "Giving", "type": "expense"},
  {"description": "Tithe", "category": "Giving", "type": "expense"},
  {"description": "Internet bill", "category": "Utilities", "type": "expense"},
  {"description": "Mpamba sent", "category": "Transfers", "type": "expense"},
  {"description": "Airtel money sent", "category": "Transfers", "type": "expense"},
  {"description": "Haircut", "category": "Personal Care", "type": "expense"},
  {"description": "Salon", "category": "Personal Care", "type": "expense"},
  {"description": "Inventory restock", "category": "Business", "type": "expense"},
  {"description": "Supplier payment", "category": "Business", "type": "expense"},
  {"description": "Customer refund", "category": "Business", "type": "expense"},
  {"description": "Petty cash", "category": "Business", "type": "expense"},
  {"description": "Office rent", "category": "Business", "type": "expense"},
  {"description": "Consulting fee", "category": "Freelance", "type": "income"},
  {"description": "Project payment", "category": "Freelance", "type": "income"},
];
